import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { Container, Box, Card, CardActionArea, CardContent, Typography, Avatar } from '@mui/material';

import { CircularProgress } from '@mui/material';
import HttpsIcon from '@mui/icons-material/Https';

import { message } from 'antd';

function Clients() {
  const [permissionError, setPermissionError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [messageApi, contextHolder] = message.useMessage();

  const checkPermissions = async () => {
    const token = localStorage.getItem('token');
    if (!token) {
      messageApi.error('No se encontró el token de autenticación.');
      setPermissionError(true);
      window.location.href = '/sign-in'; // Redirect to login if no token
      return;
    }
    setPermissionError(false);
    setIsLoading(true);
    try {
      const response = await fetch('https://dprincess-training.servehttp.com/users/check-modify-role-permissions', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });
      if (response.status === 403) {
        messageApi.error('No tienes permisos para acceder a esta sección.');
        setPermissionError(true);
        throw new Error('No tienes permisos para acceder a esta sección.');
      }
    } catch (error) {
      messageApi.error(error.message || 'Error al verificar permisos.');
      throw error; // Re-throw to handle it in the calling function
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    checkPermissions();
  }, []);

  const navigate = useNavigate();

  const handleNavigate = (path) => {
    setTimeout(() => {
      navigate(path)
    }, 100)
  }

  const clientMenuOptions = [
    {
      title: 'Gestionar clientes',
      description: 'Gestionar la lista de clientes.',
      path: `/clients/manage-clients`
    }
  ]

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (permissionError) {
    return (
      <Container maxWidth="sm" sx={{ py: 8 }}>
        <Box sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '60vh',
          gap: 2
        }}>
          <Avatar sx={{ bgcolor: '#f44336', width: 64, height: 64 }}>
            {/* Icono de candado para indicar acceso restringido */}
            <HttpsIcon sx={{ fontSize: 40 }} />
          </Avatar>
          <Typography variant="h5" sx={{ color: '#f44336', fontWeight: 700 }}>
            No tienes permiso para acceder a esta sección
          </Typography>
          <Typography variant="body1" sx={{ color: '#666', textAlign: 'center' }}>
            Esta información solo está disponible para usuarios con permisos de administrador.
          </Typography>
        </Box>
      </Container>
    );
  };
  
  return (
    <Container className='events-menu-main-container'>
      <Box className='events-menu-container'>
        {clientMenuOptions.length > 0 && clientMenuOptions.map((option, index) => (
          <div className='event-reservation grid-obj' key={index}>
            <Card sx={{ width: 275, height: 180 }}>
              <CardActionArea sx={{ height: 180 }} onClick={() => handleNavigate(option.path)}>
                <CardContent sx={{ display: 'flex', flexDirection: 'column', height: 150, justifyContent: 'space-between' }}>
                  <div className='content-container'>
                    <Typography sx={{ color: '#4b0082' }} gutterBottom variant="h5" component="div">
                      {option.title}
                    </Typography>
                    <Typography variant="body2" sx={{ color: 'text.secondary', textAlign: 'justify' }}>
                      {option.description}
                    </Typography>
                  </div>
                </CardContent>
              </CardActionArea>
            </Card>
          </div>
        ))}
      </Box>
    </Container>
  )
}

export default Clients